import React from 'react';

/**
 * One-shot hint when the player scores while audio is muted.
 * @param {{ visible: boolean, message: string, onEnable: () => void }} props
 */
export function SoundEnableHint({ visible, message, onEnable }) {
    if (!visible) return null;

    return (
        <div className="lp-game__sound-hint" role="status">
            <span className="lp-game__sound-hint-text">{message}</span>
            <button type="button" className="lp-game__sound-hint-button" onClick={onEnable}>
                🔊
            </button>
        </div>
    );
}
